export const blogPosts = [
    {
      id: "1",
      title: "React Nedir?",
      content: "React, kullanıcı arayüzleri geliştirmek için kullanılan bir JavaScript kütüphanesidir.",
      date: "2025-02-10"
    },
    {
      id: "2",
      title: "TypeScript ile React Kullanımı",
      content: "TypeScript, React uygulamalarında daha güvenli kod yazmayı sağlar.",
      date: "2025-02-08"
    },
    {
      id: "3",
      title: "Frontend Development",
      content: "Frontend geliştirme, HTML, CSS ve JavaScript ile web arayüzleri oluşturmaktır.",
      date: "2025-02-05"
    }
  ];
  